module.exports = __webpack_public_path__ + "img/IMG021.78b90dad.jpg";